import { render, staticRenderFns } from "./Ipay88SuccessPageComponent.vue?vue&type=template&id=15c239d5&scoped=true&"
import script from "./Ipay88SuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./Ipay88SuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./Ipay88SuccessPageComponent.vue?vue&type=style&index=0&id=15c239d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c239d5",
  null
  
)

export default component.exports